/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Dashboard_X_MembersInputs */

const en_admin_dashboard_x_members = /** @type {(inputs: Admin_Dashboard_X_MembersInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} member`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} members`);
	return /** @type {LocalizedString} */ ("admin.dashboard.x_members");
};

const de_admin_dashboard_x_members = /** @type {(inputs: Admin_Dashboard_X_MembersInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("de", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} Mitglied`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} Mitglieder`);
	return /** @type {LocalizedString} */ ("admin.dashboard.x_members");
};

const es_admin_dashboard_x_members = /** @type {(inputs: Admin_Dashboard_X_MembersInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} miembro`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} miembros`);
	return /** @type {LocalizedString} */ ("admin.dashboard.x_members");
};

const fr_admin_dashboard_x_members = /** @type {(inputs: Admin_Dashboard_X_MembersInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fr", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} membre`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} membres`);
	return /** @type {LocalizedString} */ ("admin.dashboard.x_members");
};

const it_admin_dashboard_x_members = /** @type {(inputs: Admin_Dashboard_X_MembersInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("it", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} membro`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} membri`);
	return /** @type {LocalizedString} */ ("admin.dashboard.x_members");
};

const pt_br2_admin_dashboard_x_members = /** @type {(inputs: Admin_Dashboard_X_MembersInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pt-BR", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} membro`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} membros`);
	return /** @type {LocalizedString} */ ("admin.dashboard.x_members");
};

const pl_admin_dashboard_x_members = /** @type {(inputs: Admin_Dashboard_X_MembersInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pl", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} członek`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} członków`);
	return /** @type {LocalizedString} */ ("admin.dashboard.x_members");
};

const hu_admin_dashboard_x_members = /** @type {(inputs: Admin_Dashboard_X_MembersInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("hu", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} tag`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} tag`);
	return /** @type {LocalizedString} */ ("admin.dashboard.x_members");
};

/** @type {(inputs: Admin_Dashboard_X_MembersInputs) => LocalizedString} */
const ro_admin_dashboard_x_members = en_admin_dashboard_x_members;

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} member" |
* | "other" | "{count} members" |
*
* @param {Admin_Dashboard_X_MembersInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_x_members = /** @type {((inputs: Admin_Dashboard_X_MembersInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_X_MembersInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_x_members(inputs)
	if (locale === "de") return de_admin_dashboard_x_members(inputs)
	if (locale === "es") return es_admin_dashboard_x_members(inputs)
	if (locale === "fr") return fr_admin_dashboard_x_members(inputs)
	if (locale === "it") return it_admin_dashboard_x_members(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_x_members(inputs)
	if (locale === "pl") return pl_admin_dashboard_x_members(inputs)
	if (locale === "hu") return hu_admin_dashboard_x_members(inputs)
	return ro_admin_dashboard_x_members(inputs)
});
export { admin_dashboard_x_members as "admin.dashboard.x_members" }